export const removeLeadingSlash = (href: string) => {
    return href.replace(/^\/+/g, "");
};
